import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { GenericEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/GenericEvaluator";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { NAMESPACE } from "./_Namespace";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";

export type EntityCommandProcessInstanceItemReopenCasePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemReopenCaseProperties = {
    [name in keyof EntityCommandProcessInstanceItemReopenCasePropertyValues]: Property<EntityCommandProcessInstanceItemReopenCasePropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemReopenCase extends IEntityCommand, EntityCommandProcessInstanceItemReopenCaseProperties
{
}

export class EntityCommandProcessInstanceItemReopenCase extends EntityCommand implements IEntityCommandProcessInstanceItemReopenCase
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemReopenCase";
    public static override className = "EntityCommandProcessInstanceItemReopenCase";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemReopenCasePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Reopen Case Here",
                entityName: "ProcessInstanceItem",
                key: "REOPEN_CASE_HERE",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
                visibleEvaluator: new GenericEvaluator({
                    evaluateFn: (_, state) =>
                    {
                        if (!(state instanceof EntityCommandInformation))
                            return false;

                        if (state.record.get()?.statusLookupItem?.description !== "Completed")
                            return false;

                        if (state.record.get()?.processInstance?.entityId !== "8a8fcf9d-ab26-43cc-b6da-0383900ebdcc")
                            return false;

                        if (["Completed", "Terminated"].indexOf(state.record.get()?.processInstance?.statusLookupItem?.description) < 0)
                            return false;

                        return true;
                    }
                }),
            }
        };
    }
    public static override getRequiredFields()
    {
        return [
            ...super.getRequiredFields(),
            "processInstance.entityId",
            "processInstance.statusLookupItem.description",
            "statusLookupItem.description",
        ];
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemReopenCasePropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            record = entityCommandInformation.record.get(),
            processInstanceItemId = record?.id;

        if (!processInstanceItemId)
            return;

        const
            result =
                await MessageDialog.displayMessage("Reopen Case?", "Are you sure you want to reopen the case?", ButtonStyleEnum.yesNo);

        if (result.dialogResult !== DialogResultEnum.yes)
            return;

        await
            ServiceManager.getRequired(WebApiClientService)
                .createApiMethodRequest(
                    "case",
                    "reopen",
                    {
                        processInstanceItemId,
                    },
                )
                .executeAsync();

        entityCommandInformation.caller.get()?.triggerHandler("activityChanged");
    }

    // #endregion

    // #endregion
}

